// src/components/DevicePanel/Map/MarkerManager/index.tsx

import React from "react";
import { LatLngTuple, Icon } from "leaflet";
import "./index.css";
import TrapMarker from "./Marker";

export interface MarkerData {
  id: string | number;
  position: LatLngTuple;
  title?: string;
  content?: React.ReactNode;
  popupWidth?: number;
  popupMaxWidth?: number;
  icon?: Icon;
  zIndexOffset?: number;
  warning?: boolean;
  traps?: { displayName?: string; warning?: boolean }[];
  trapCount?: number;
  detectionsCount?: number;
}

export interface MarkerManagerProps {
  markers?: MarkerData[];
  defaultIcon?: Icon;
  renderPopup?: (marker: MarkerData) => React.ReactNode;
  map_center?: any;
}

const MarkerManager: React.FC<MarkerManagerProps> = ({
  markers,
  defaultIcon,
  renderPopup,
  map_center,
}) => {
  const tmpMarkers: MarkerData[] = [
    {
      id: "device-1",
      position: [map_center[0], map_center[1]] as LatLngTuple,
      title: "Current Device Location",
      content: `Lat: ${map_center[0]?.toFixed(5)}<br/>Lon: ${map_center[1]?.toFixed(5)}`,
      warning: true,
      traps: [
        { displayName: "123", warning: true },
        { displayName: "456", warning: false },
      ],
      trapCount: 2,
      detectionsCount: 0,
    },
    {
      id: "location-1",
      position: [map_center[0] + 0.01, map_center[1] + 0.01] as LatLngTuple,
      title: "Nearby Location",
      content: "A nearby point of interest",
      warning: true,
      traps: [
        { displayName: "123", warning: false },
        { displayName: "456", warning: false },
      ],
      trapCount: 5,
      detectionsCount: 3,
    },
    {
      id: "location-1",
      position: [map_center[0] + 0.04, map_center[1] + 0.01] as LatLngTuple,
      title: "Nearby Location",
      content: "A nearby point of interest",
      warning: false,
      traps: [{ displayName: "123", warning: false }],
      detectionsCount: 3,
    },
    {
      id: "location-1321321312132132",
      position: [map_center[0] + 0.05, map_center[1] + 0.01] as LatLngTuple,
      title: "Nearby Location",
      content: "A nearby point of interest",
      warning: true,
      traps: [{ displayName: "123", warning: true }],
      detectionsCount: 3,
    },
  ];

  if (tmpMarkers.length === 0) return null;

  return (
    <>
      {tmpMarkers.map((marker, index) => (
        <TrapMarker marker={marker} key={`trap-${index}`} />
      ))}
    </>
  );
};

export default MarkerManager;
